import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import '../styles/SubirArchivo.css'

function SubirArchivo(props) {
    const { API_DEFAULT, setShowAlert, setMessage, setSeverity, setShowBackdrop, accessToken, validateToken, logout } = props;
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState('Selecciona el archivo a subir');
    const [fileNameCust, setFileNameCust] = useState('');
    const months = {
        'enero': '01',
        'febrero': '02',
        'marzo': '03',
        'abril': '04',
        'mayo': '05',
        'junio': '06',
        'julio': '07',
        'agosto': '08',
        'septiembre': '09',
        'octubre': '10',
        'noviembre': '11',
        'diciembre': '12'
    }

    // Nombres exactos de hojas permitidas
    const allowedSheetNames = ['Escuela TIC', 'Piensa en grande', 'Profuturo', 'Autoformacion'];

    // Función para mostrar alertas popup más evidentes
    const showPopupAlert = (message, type = 'error') => {
        const icons = {
            error: '❌',
            warning: '⚠️',
            info: 'ℹ️'
        };
        window.alert(`${icons[type]} ${message}`);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const validateExcelSheets = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const sheetNames = workbook.SheetNames;
                    
                    // Verificar que todas las hojas tengan nombres permitidos
                    const invalidSheets = sheetNames.filter(name => !allowedSheetNames.includes(name));
                    
                    if (invalidSheets.length > 0) {
                        reject(`El archivo contiene hojas con nombres no permitidos: ${invalidSheets.join(', ')}. Solo se permiten las hojas: ${allowedSheetNames.join(', ')}`);
                    } else {
                        resolve(true);
                    }
                } catch (error) {
                    reject('Error al leer el archivo Excel. Asegúrate de que sea un archivo válido.');
                }
            };
            reader.onerror = () => reject('Error al leer el archivo.');
            reader.readAsArrayBuffer(file);
        });
    };

    const loadFile = async (event) => {
        let file = event.target.files[0];
        event.target.value = null;
        
        // Verificar que sea un archivo Excel
        if (!['xls', 'xlsx'].includes(file.name.split('.')[1])) {
            const message = 'Solo se permiten archivos Excel (.xls o .xlsx).';
            showPopupAlert(message, 'error');
            setMessage(message);
            setSeverity('warning');
            setTimeout(() => { setShowAlert(true) }, 0);
            return;
        }

        // Validar las hojas del Excel
        try {
            await validateExcelSheets(file);
            
            // Si pasa la validación de hojas, continuar con la validación de nombre
            let splitName = file.name.split(' ')
            if (splitName.length === 3 && splitName[0] === 'Consulta' && splitName[1].length === 2 && months[splitName[2].split('.')[0].toLowerCase()] !== undefined) {
                let month = months[splitName[2].split('.')[0].toLowerCase()]
                let day = splitName[1]
                let extension = splitName[2].split('.')[1]
                setFileNameCust(`Consulta 2025-${month}-${day}.${extension}`);
                setFile(file);
                setFileName(file.name);
                setMessage('Archivo Excel válido seleccionado correctamente.');
                setSeverity('success');
                setTimeout(() => { setShowAlert(true) }, 0);
            }
            else {
                const message = `FORMATO DE NOMBRE INCORRECTO\n\nEl nombre del archivo debe ser exactamente:\n"Consulta DD MES.xlsx"\n\nEjemplo: "Consulta 01 Enero.xlsx"\n\nTu archivo: "${file.name}"`;
                showPopupAlert(message, 'warning');
                setMessage('El nombre del archivo no es compatible.');
                setSeverity('info');
                setTimeout(() => { setShowAlert(true) }, 0);
            }
        } catch (error) {
            const message = `ERROR EN LAS HOJAS DEL EXCEL\n\n${error}\n\nRecuerda: Solo se permiten hojas con los nombres exactos:\n• Escuela TIC\n• Piensa en grande\n• Profuturo\n• Autoformacion`;
            showPopupAlert(message, 'error');
            setMessage(error);
            setSeverity('error');
            setTimeout(() => { setShowAlert(true) }, 0);
        }
    }

    const uploadFile = async () => {
        setShowBackdrop(true);
        const formData = new FormData();
        const renamedFile = new File([file], fileNameCust)
        formData.append('file', renamedFile);

        const res = await fetch(`${API_DEFAULT}/upload-file`, {
            method: 'POST',
            headers: { 'x-access-tokens': accessToken },
            body: formData
        })

        if (res.ok) {
            res
                .json()
                .then(d => {
                    if (d['message'] === 'token is invalid') {
                        logout();
                        setMessage('La sesión a caducado, ingrese nuevamente.');
                        setSeverity('warning');
                    }
                    else {
                        setMessage('El archivo fue subido exitosamente.');
                        setSeverity('success');
                    }
                })
        }
        else {
            setMessage('Ha ocurrido un error, intentelo de nuevo.');
            setSeverity('danger');
        }

        setFile(null);
        setFileName('Selecciona el archivo a subir');
        setFileNameCust('');
        setShowBackdrop(false);
        setTimeout(() => { setShowAlert(true) }, 0);
    }

    useEffect(() => {
        validateToken();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Form onSubmit={handleSubmit} className='card subir-card-container'>
            <Form.Group>
                <Form.Label>Archivo Excel a subir (<i>xls</i> ó <i>xlsx</i>)</Form.Label>
                <Form.Label style={{ fontSize: 13, margin: 0, display: 'block' }}>El archivo debe tener un nombre de la forma: <i>Consulta 'numero_día' 'nombre_mes'.'extensión'</i></Form.Label>
                <Form.Label style={{ fontSize: 13, display: 'block' }}>- Por ejemplo: <i>Consulta 01 Enero.xlsx</i></Form.Label>
                <Form.Label style={{ fontSize: 13, display: 'block', color: '#dc3545', fontWeight: 'bold' }}>
                    ⚠️ El Excel solo puede contener hojas con estos nombres exactos:
                </Form.Label>
                <Form.Label style={{ fontSize: 12, display: 'block', color: '#6c757d', marginLeft: '15px' }}>
                    • 'Escuela TIC' • 'Piensa en grande' • 'Profuturo' • 'Autoformacion'
                </Form.Label>
                <Form.Label style={{ fontSize: 12, display: 'block', color: '#6c757d' }}>
                    (Pueden faltar hojas, pero no puede haber hojas con otros nombres)
                </Form.Label>
                <Form.File
                    custom
                    data-browse='Buscar'
                    label={fileName}
                    onChange={loadFile}
                    accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                />
            </Form.Group>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {/* <Button disabled={true} variant='dark' type='submit'>Subir archivo</Button> */}
                <Button disabled={!file} variant='dark' type='submit' onClick={() => uploadFile()}>Subir archivo</Button>
            </div>
        </Form>
    );
}

export default SubirArchivo;